export default __webpack_public_path__ + "static/media/pms3.3036677b.png";